// Module
var code = "<div class=\"myAccount-wrapper\"><div class=\"main-tab\"><div class=\"ee-container\"><h1>MY ACCOUNT</h1></div></div><div class=\"ee-container\"><div class=\"main-content bottom-line-divider\"><div layout=\"row\"><div flex><account-actions-menu></account-actions-menu><h2>Edit General Info</h2></div></div></div></div></div>";
// Exports
module.exports = code;